export const ERROR_SEGUIMIENTO_LIST = 'channelmap/reporteseguimiento/error-seguimiento-list';
export const RECEIVE_SEGUIMIENTO_LIST = 'channelmap/reporteseguimiento/receive-seguimiento-list';
export const REQUEST_SEGUIMIENTO_LIST = 'channelmap/reporteseguimiento/request-seguimiento-list';
export const RESTART_STATE = 'channelmap/reporteseguimiento/restart_state';
export const SET_MASK = 'channelmap/reporteseguimiento/set-mask';
export const SET_ORDER = 'channelmap/reporteseguimiento/set-order';
export const SET_SELECTED_ROW = 'channelmap/reporteseguimiento/set-selected-row';
export const UPDATE_FIELD_FILTER = 'channelmap/reporteseguimiento/update-field-filter';                   
export const UPDATE_FIELD_DATA = 'channelmap/reporteseguimiento/update-field-data';
export const UPDATE_TABLE_COLUMN = 'channelmap/reporteseguimiento/set-selected-row';